import { Loader } from '@grafikr/components';

export default Loader(({ node }, load) => {
  const event = node.dataset.loadEvent ?? 'click';
  node.addEventListener(event, load);
});
